import { render, staticRenderFns } from "./SupportCategory.vue?vue&type=template&id=222856ec&scoped=true&"
import script from "./SupportCategory.vue?vue&type=script&lang=js&"
export * from "./SupportCategory.vue?vue&type=script&lang=js&"
import style0 from "./SupportCategory.vue?vue&type=style&index=0&id=222856ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222856ec",
  null
  
)

export default component.exports